export default "__VITE_ASSET__Dka1wfdK__"